<template>
  <div class="general-wrapper">
      <form class="custom-form w-320" v-if="innerProject">
        <div class="mb-3">
          <label for="project-id" class="col-form-label">Project ID</label>
          <input type="text" name="project-id" v-model="innerProject.id" readonly
          class="form-control" id="project-id">
        </div>
        <div class="mb-3">
          <label for="project-name" class="col-form-label">Name</label>
          <input type="text" name="project-name" v-model="innerProject.name" class="form-control"
          id="project-name">
        </div>
        <div class="mb-3">
          <label for="project-name" class="col-form-label">Descripton</label>
          <textarea
            rows="3"
            type="text"
            name="project-name"
            v-model="innerProject.description"
            class="form-control"
            id="project-name" />
        </div>
        <Button :onClick="onClickUpdateForm" :dynamicAttrs="dynamicAttrsButton">Update</Button>
      </form>
  </div>
</template>

<script type="ts">
import { defineComponent } from 'vue';
import Button from '@/components/Button/template.vue';
import { message } from 'ant-design-vue';
import Project from '../../../models/Project';
import { projectsMapper } from '../../../store';
import './styles.scss';

export default defineComponent({
  name: 'ProjectDetails',
  components: {
    Button,
  },
  props: {
    project: {
      type: Project,
      default: {},
    },
  },
  data() {
    return {
      dynamicAttrsButton: {
        loading: false,
      },
      innerProject: { ...this.project },
    };
  },
  methods: {
    ...projectsMapper.mapActions(['update']),
    async onClickUpdateForm() {
      this.dynamicAttrsButton.loading = true;
      const { data } = await this.update({
        slug: this.$route.params.slug,
        project: this.innerProject,
      });
      if (data) {
        message.success('Update project successfully');
      }
      this.dynamicAttrsButton.loading = false;
    },
  },
});
</script>
